module.exports = __webpack_public_path__ + "img/yakor.f1f51f73.png";